import React from 'react';
import cx from 'clsx';
import type { U } from 'ts-toolbelt';

import styles from './Skeleton.module.css';

type Props = {
  count?: number;
  style?: React.CSSProperties;
  gap?: number;
  center?: boolean;
  className?: string;
} & U.Strict<
  | {
      width?: number | string;
      height: number | string;
    }
  | {
      width: number | string;
      roundedFull: true;
    }
>;

function Skeleton({
  width,
  height,
  roundedFull,
  style: customStyle,
  center,
  count = 1,
  gap = 0,
  className,
}: Props) {
  const elements = Array.from({ length: count });
  const style = {} as React.CSSProperties;

  if (center) {
    style.marginLeft = 'auto';
    style.marginRight = 'auto';
  }

  if (roundedFull) {
    style.width = width;
    style.height = width;
    style.borderRadius = '50%';
  } else {
    style.width = width || '100%';
    style.height = height;
    style.borderRadius = '16px';
  }

  return (
    <>
      {elements.map((_, index) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          className={cx([styles.wrapper, className])}
          style={{
            marginBottom: elements.length !== index + 1 ? gap : 0,
            ...style,
            ...customStyle,
          }}
        >
          &zwnj;
        </div>
      ))}
    </>
  );
}

export default Skeleton;
